(() => {
  const getVariant = (form) => {
    const input = form.querySelector('[name="id"]');
    const data = form.querySelector('[data-tiktok-shop-variants]');
    if (!input || !data) return null;

    try {
      return JSON.parse(data.textContent).find((variant) => String(variant.id) === String(input.value)) || null;
    } catch (error) {
      return null;
    }
  };

  const syncForm = (form) => {
    const cta = form.querySelector('[data-tiktok-shop-cta]');
    const variant = getVariant(form);
    if (!cta || !variant) return;
    cta.hidden = variant.available;
  };

  const syncAll = () => {
    document.querySelectorAll('[data-tiktok-shop-product-form]').forEach(syncForm);
  };

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-tiktok-shop-product-form]');
    if (form) setTimeout(() => syncForm(form));
  });

  document.addEventListener('product:variant-change', () => setTimeout(syncAll));
  document.addEventListener('shopify:section:load', syncAll);
  syncAll();
})();
